import type {ApiWorkforceProfileRecord} from './workforceProfileApiTypes';
import type {LocalisedPropertyValue} from '../../../../../types/shared-types';


export const mapCultureType = (raw: ApiWorkforceProfileRecord | undefined): LocalisedPropertyValue | null => {
  if (!raw) {
    return null;
  }

  const en = String(raw.nameEn ?? raw.name_en ?? raw.en ?? '').trim();
  const de = String(raw.nameDe ?? raw.name_de ?? raw.de ?? '').trim();

  if (!en && !de) {
    return null;
  }

  return {en: en || de, de: de || en};
};
